(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/winner-ticker/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/widgets/winner-ticker/assets/javascripts/utils.js');
"use strict";


const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : null;
let constants;
let urlMapping;
let logger;
if (svs.isServer) {
  constants = require('./constants.es6');
  urlMapping = trinidad.urlMapping;
  logger = trinidad.logger('widgets:winner-ticker:utils');
} else {
  constants = svs.widget.winner_ticker.constants;
  urlMapping = svs.core.urlMapping;
  logger = svs.core.log.getLogger('widgets:winner-ticker:utils');
}
const _constants = constants,
  TickerBrand = _constants.TickerBrand,
  TickerFeed = _constants.TickerFeed;
const getAmount = (winner, useCloudCasinoApis) => Math.floor(useCloudCasinoApis ? winner.amount / 100 : winner.amountSek);
const getTimeStamp = (winner, useCloudCasinoApis) => useCloudCasinoApis ? String(winner.timeStamp) : winner.timeStamp;
const getBrand = winnerSetup => {
  switch (winnerSetup) {
    case 'bingo':
      return TickerBrand.BINGO;
    case 'momangSlots':
    case 'momangLiveSlots':
      return TickerBrand.MOMANG;
    case 'casinoSlots':
    case 'casinoLiveSlots':
    default:
      return TickerBrand.CASINO;
  }
};
const getFeed = winnerSetup => {
  switch (winnerSetup) {
    case 'bingo':
      return TickerFeed.BINGO;
    case 'casinoLiveSlots':
    case 'momangLiveSlots':
      return TickerFeed.LIVE_CASINO;
    case 'casinoSlots':
    case 'momangSlots':
    default:
      return TickerFeed.SLOTS;
  }
};
const normalizeBingoWinnersClient = (winners, gameRooms) => winners.map(winner => {
  const useCloudCasinoApis = svs.core.detect.feature('ft-use-casino-cloud-apis');
  const gameRoom = gameRooms.find(room => room.name === winner.game.name);
  const imageSrc = constants.BingoImgSrc[gameRoom.id];
  return {
    gameName: winner.game.name,
    amount: getAmount(winner, useCloudCasinoApis),
    href: gameRoom ? "".concat(urlMapping.get('bingoHome'), "/spela/").concat(gameRoom.id, "?gameName=").concat(gameRoom.name) : null,
    id: getTimeStamp(winner, useCloudCasinoApis),
    imageSrc
  };
});
const normalizeBingoWinnersServer = async (winners, gameRooms, req) => {
  const useCloudCasinoApis = await req.feature('ft-use-casino-cloud-apis');
  return winners.map(winner => {
    const gameRoom = gameRooms.find(room => room.name === winner.game.name);
    const imageSrc = constants.BingoImgSrc[gameRoom.id];
    return {
      gameName: winner.game.name,
      amount: getAmount(winner, useCloudCasinoApis),
      href: gameRoom ? "".concat(urlMapping.get('bingoHome'), "/spela/").concat(gameRoom.id, "?gameName=").concat(gameRoom.name) : null,
      id: getTimeStamp(winner, useCloudCasinoApis),
      imageSrc
    };
  });
};
const localCasinoTickerGameCache = {};
const createCasinoTickerGame = gameData => {
  const casinoTickerGame = {
    name: gameData.name,
    title: gameData.title,
    opsGameId: gameData.opsGameId,
    image: gameData.lobbyImage
  };
  return casinoTickerGame;
};
const createWinnerItem = _ref => {
  let winner = _ref.winner,
    casinoTickerGame = _ref.casinoTickerGame,
    returnUrl = _ref.returnUrl,
    useCloudCasinoApis = _ref.useCloudCasinoApis;
  let href;
  if (casinoTickerGame.name) {
    href = "".concat(urlMapping.get('casinoGameInfo'), "/").concat(casinoTickerGame.name);
    if (returnUrl) {
      href += "?returnUrl=".concat(encodeURIComponent(returnUrl));
    }
  }
  return {
    gameName: casinoTickerGame.title,
    amount: getAmount(winner, useCloudCasinoApis),
    href,
    id: getTimeStamp(winner, useCloudCasinoApis),
    image: casinoTickerGame.image
  };
};
const normalizeCasinoWinnersServer = async (winners, req, res) => {
  var _trinidad$components$, _trinidad$components$2;
  const useCloudCasinoApis = await req.feature('ft-use-casino-cloud-apis');
  const gameCacheGames = (_trinidad$components$ = (_trinidad$components$2 = trinidad.components.require('casino', 'game-cache').getGameCache()) === null || _trinidad$components$2 === void 0 ? void 0 : _trinidad$components$2.games) !== null && _trinidad$components$ !== void 0 ? _trinidad$components$ : {};
  const gameCacheGamesList = Object.values(gameCacheGames !== null && gameCacheGames !== void 0 ? gameCacheGames : {});
  const clientGameCache = trinidad.components.require('casino-react', 'client-gamecache');
  const reqLocalCasinoTickerGameCache = {};
  const mappedWinners = winners.map(winner => {
    const winnerOpsGameId = useCloudCasinoApis ? String(winner.game.level3) : winner.game.level3;

    let cachedCasinoTickerGame = reqLocalCasinoTickerGameCache[winnerOpsGameId];

    if (!cachedCasinoTickerGame) {
      let gameData = gameCacheGamesList.find(game => game.opsGameId === winnerOpsGameId || game.opsGameIdMobile === winnerOpsGameId);
      if (gameData) {
        clientGameCache.addClientGamecacheGame(res, gameData.name);
      } else {
        gameData = {
          title: winner.game.name,
          name: null,
          opsGameId: winnerOpsGameId
        };
        logger.info("Winner-ticker fallback game. Title: ".concat(winner.game.name, ", opsGameId: ").concat(winnerOpsGameId));
      }
      cachedCasinoTickerGame = createCasinoTickerGame(gameData);
      reqLocalCasinoTickerGameCache[winnerOpsGameId] = cachedCasinoTickerGame;
    }
    return createWinnerItem({
      winner,
      casinoTickerGame: cachedCasinoTickerGame,
      returnUrl: req.url,
      useCloudCasinoApis
    });
  });
  clientGameCache.precookClientGamecache(res);
  return mappedWinners;
};

const normalizeCasinoWinnersClient = async (winners, returnUrl) => {
  const useCloudCasinoApis = svs.core.detect.feature('ft-use-casino-cloud-apis');
  const clientGameCache = svs.components.casino_react.ClientGamecache.getClientGamecache();

  const opsGameIdsToFetch = winners.reduce((acc, winner) => {
    const winnerOpsGameId = useCloudCasinoApis ? String(winner.game.level3) : winner.game.level3;

    const cachedCasinoTickerGame = localCasinoTickerGameCache[winnerOpsGameId];
    if (cachedCasinoTickerGame) {
      return acc;
    }

    const cachedGame = clientGameCache.getGameByOpsId(winnerOpsGameId);
    if (cachedGame) {
      return acc;
    }

    acc.add(winnerOpsGameId);
    return acc;
  }, new Set());
  if (opsGameIdsToFetch.size > 0) {
    await clientGameCache.populateByOpsIds(Array.from(opsGameIdsToFetch));
  }
  return winners.map(winner => {
    const winnerOpsGameId = useCloudCasinoApis ? String(winner.game.level3) : winner.game.level3;
    let cachedCasinoTickerGame = localCasinoTickerGameCache[winnerOpsGameId];
    if (!cachedCasinoTickerGame) {
      let gameData = clientGameCache.getGameByOpsId(winnerOpsGameId);
      if (!gameData) {
        gameData = {
          title: winner.game.name,
          name: null,
          opsGameId: winnerOpsGameId
        };
        logger.info("Winner-ticker fallback game. Title: ".concat(winner.game.name, ", opsGameId: ").concat(winnerOpsGameId));
      }
      cachedCasinoTickerGame = createCasinoTickerGame(gameData);
      localCasinoTickerGameCache[gameData.opsGameId] = cachedCasinoTickerGame;
    }
    return createWinnerItem({
      winner,
      casinoTickerGame: cachedCasinoTickerGame,
      returnUrl,
      useCloudCasinoApis
    });
  });
};
const addTrackingListener = (el, brand, winnerItem) => {
  const useCloudCasinoApis = svs.core.detect.feature('ft-use-casino-cloud-apis');
  el.addEventListener('click', clickEvent => {
    const url = el.getAttribute('href');
    const trackPayload = {
      action: 'game ticker',
      category: 'Navigation',
      opt_label: "".concat(brand).concat(brand === TickerBrand.BINGO ? ",".concat(winnerItem.gameName) : ''),
      opt_value: getAmount(winnerItem, useCloudCasinoApis)
    };

    if (clickEvent.button !== 0 || clickEvent.metaKey || clickEvent.ctrlKey || clickEvent.shiftKey) {
      svs.components.analytics.trackEvent(trackPayload);
      return;
    }

    if (!url) {
      svs.components.analytics.trackEvent(trackPayload);
      return;
    }
    clickEvent.preventDefault();
    svs.components.analytics.trackEvent(trackPayload, () => {
      window.location.href = url;
    });
  });
  return el;
};
const utils = {
  getBrand,
  getFeed,
  normalizeBingoWinners: svs.isServer ? normalizeBingoWinnersServer : normalizeBingoWinnersClient,
  normalizeCasinoWinners: svs.isServer ? normalizeCasinoWinnersServer : normalizeCasinoWinnersClient,
  addTrackingListener
};
if (svs.isServer) {
  module.exports = utils;
} else {
  svs.widget.winner_ticker.utils = utils;
}

 })(window);